import AlarmLightComponent from '@/components/115/AlarmLightComponent.vue';
import Toast from '@/components/app/toast.vue';
import { latLngBounds } from 'leaflet';
// import Vue from 'vue';
export default {
  data() {
    return {
      sound: {
        soundurl: require('@/assets/images/alarm.wav'),
      },
      sound2: {
        soundurl: require('@/assets/images/bottomList800.wav'),
      },
      genderItems: [
        { title: 'مرد', id: 0 },
        { title: 'زن', id: 1 },
      ],
      gender115Items: [
        { title: 'مرد', id: 1 },
        { title: 'زن', id: 2 },
        { title: 'نامشخص', id: 3 },
      ],
      genderFollowUpItems: [
        { title: 'مرد', id: 1 },
        { title: 'زن', id: 2 },
        { title: 'نامشخص', id: 3 },
      ],
      ChiefComplaintCategoryItems: [
        { title: 'بیماری', id: 0 },
        { title: 'حادثه', id: 1 },
      ],
      geographicalTypeItems: [
        { title: 'شهری', id: 0 },
        { title: 'جاده ای', id: 1 },
        { title: 'کلان شهر', id: 2 },
      ],
      triageRankItems: [
        { title: 'سفید', id: 0 },
        { title: 'سبز', id: 1 },
        { title: 'زرد', id: 2 },
        { title: 'قرمز', id: 3 },
      ],
      plateTextItems: [
        { text: 'الف', id: 1 },
        { text: 'ب', id: 2 },
        { text: 'پ', id: 3 },
        { text: 'ت', id: 4 },
        { text: 'ث', id: 5 },
        { text: 'ج', id: 6 },
        { text: 'چ', id: 7 },
        { text: 'ح', id: 8 },
        { text: 'خ', id: 9 },
        { text: 'د', id: 10 },
        { text: 'ذ', id: 11 },
        { text: 'ر', id: 12 },
        { text: 'ز', id: 13 },
        { text: 'ژ', id: 14 },
        { text: 'س', id: 15 },
        { text: 'ش', id: 16 },
        { text: 'ص', id: 17 },
        { text: 'ض', id: 18 },
        { text: 'ط', id: 19 },
        { text: 'ظ', id: 20 },
        { text: 'ع', id: 21 },
        { text: 'غ', id: 22 },
        { text: 'ف', id: 23 },
        { text: 'ق', id: 24 },
        { text: 'ک', id: 25 },
        { text: 'گ', id: 26 },
        { text: 'ل', id: 27 },
        { text: 'م', id: 28 },
        { text: 'ن', id: 29 },
        { text: 'و', id: 30 },
        { text: 'ه', id: 31 },
        { text: 'ی', id: 32 },
      ],
      passwordHint:
        'رمز عبور باید شامل حداقل 8 کاراکتر باشد. همچنین متشکل از حروف بزرگ و کوچک انگلیسی، اعداد و کاراکترهای خاص باشد (دارا بودن حداقل 3 شرط الزامی است).',
      patientRelationList: [
        { title: 'پدر', id: 1 },
        { title: 'مادر', id: 2 },
        { title: 'خواهر', id: 3 },
        { title: 'برادر', id: 3 },
        { title: 'رهگذر', id: 5 },
        { title: 'سایر', id: 6 },
      ],
      missionInformTypeItems: [
        { title: 'تلفنی', id: 1 },
        { title: 'حضوری', id: 2 },
      ],
      priorityList: [
        { title: 1, id: 1 },
        { title: 2, id: 2 },
        { title: 3, id: 3 },
        { title: 4, id: 4 },
        { title: 5, id: 5 },
        { title: 6, id: 6 },
        { title: 7, id: 7 },
        { title: 8, id: 8 },
      ],
      isWithinCityList: [
        { title: 'درون شهری', id: 1, info: true },
        { title: 'برون شهری', id: 2, info: false },
      ],
      missionPlaceTypeList: [
        { title: 'مسکونی', id: 1 },
        { title: 'صنعتی', id: 2 },
        { title: 'آموزشی', id: 3 },
        { title: 'مراکز درمانی', id: 4 },
        { title: 'اماکن ورزشی و تفریحی', id: 5 },
        { title: 'اداری', id: 6 },
        { title: 'معابر ترافیکی', id: 7 },
        { title: 'آزاد راه', id: 8 },
        { title: 'بزرگراه', id: 9 },
        { title: 'راه اصلی', id: 10 },
        { title: 'راه فرعی', id: 11 },
        { title: 'راه روستایی', id: 12 },
      ],
      withOutPatientResultList: [
        // { title: 'عدم همکاری از هر نوع اقدام درمانی', id: 6 },
        { title: 'لغو از طرف مرکز هدایت و کنترل', id: 7 },
        { title: 'ماموریت کاذب/اشتباه', id: 8 },
        { title: 'عدم حضور بیمار', id: 9 },
        { title: 'استقرار', id: 10 },
      ],
      nationalityList: [
        { title: 'ایرانی', id: 1 },
        { title: 'افغانستانی', id: 3 },
        { title: 'سایر اتباع', id: 2 },
        { title: 'نامشخص', id: 4 },
      ],
      navigationList: [],
      // getJalaliDate: function (date) {
      //   return Vue.moment(date).format('jYYYY/jMM/jDD-HH:mm:ss');
      // },
    };
  },
  methods: {
    closeAllNewTabs() {
      const tabs = this.$store.state.TabModule?.navigationList || [];

      if (tabs.length === 0) {
        return;
      }

      tabs.forEach(item => {
        try {
          if (item?.tab && !item.tab.closed) {
            item.tab.close();
          }
        } catch (error) {
          console.error('خطا :', error);
        }
      });

      this.$store.commit('TabModule/SET_LIST', []);
    },
    closeNewTabByHref(href) {
      this.$store.dispatch('closeTabByHref', href)
    },
    navigateTo: function (name, option) {
      const pageRoute = this.$router.resolve({ name, option }).href;

      this.$store.dispatch('focusBlankPage', pageRoute);
    },
    getNavigationListStorage: function () {
      return JSON.parse(window.sessionStorage.getItem('--asayar-navigation-list--') || '[]');
    },
    updateSessionStorage: function (navigationList) {
      if (navigationList?.length)
        window.sessionStorage.setItem('--asayar-navigation-list--', JSON.stringify(navigationList));
      else window.sessionStorage.clear();
    },
    removeFromNavigateList: function () { },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      const allowOtherKey = ['Backspace', 'Escape', 'ArrowLeft', 'ArrowRight', '.'].includes(
        evt.key,
      );
      if (charCode > 31 && (charCode < 48 || charCode > 57) && !allowOtherKey) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberWithDot: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberWithSpace: function (evt) {
      const allowKeys = [',', '/', '-'];
      const keyPressed = evt.key;
      if (
        !keyPressed.match(/^[0-9]$/) &&
        !allowKeys.some((key) => key === keyPressed) &&
        evt.code !== 'Space'
      ) {
        evt.preventDefault();
        return;
      }
    },
    removeLastCharechter: function (data) {
      if (data != null && data.length > 0 && data.charAt(data.length - 1) == ',') {
        data = data.substring(0, data.length - 1);
      }
      if (data != null && data.length > 0 && data.charAt(data.length - 1) == '-') {
        data = data.substring(0, data.length - 1);
      }
      if (data != null && data.length > 0 && data.charAt(data.length - 1) == '،') {
        data = data.substring(0, data.length - 1);
      }
      if (data != null && data.length > 0 && data.charAt(data.length - 1) == ')') {
        data = data.substring(0, data.length - 1);
      }
      return data;
    },
    toastContent: function (text, link) {
      return {
        component: Toast,
        // Props are just regular props, but these won't be reactive
        props: {
          link: !!link,
          text,
        },
        // Listeners will listen to and execute on event emission
        listeners: {
          click: () => this.navigateTo(link),
        },
      };
    },
    showTostMessage: function (text) {
      this.$toast(text, {
        position: 'bottom-right',
        timeout: 10000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: 'button',
        icon: true,
        rtl: true,
      });
    },
    showTostMessage2: function (
      text,
      link,
      configs = {
        timeout: false,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
      },
    ) {
      const is800Routes = this.$route.path.includes('/800');
      const isAdmissionRoutes = this.$route.path.includes('/admission/mission');
      if (is800Routes || isAdmissionRoutes) {
        this.$toast(this.toastContent(text, link), {
          position: 'bottom-left',
          ...configs,
          // timeout: false,
          timeout: 8000,
          draggable: false,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: 'button',
          icon: true,
          rtl: false,
        });
      }
    },
    showTostAlarm: function () {
      this.$toast.error(AlarmLightComponent, {
        position: 'top-left',
        timeout: 3000,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        draggable: true,
        draggablePercent: 0.88,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: false,
        icon: false,
        rtl: false,
      });
    },
    resetPage: function () {
      this.this.pagination.pageNumber = 1;
    },
    getRandomRolor: function () {
      var letters = '012345'.split('');
      var color = '#';
      color += letters[Math.round(Math.random() * 5)];
      letters = '0123456789ABCDEF'.split('');
      for (var i = 0; i < 5; i++) {
        color += letters[Math.round(Math.random() * 15)];
      }
      return color;
    },
    onOpen: function (info) {
      info.goToday();
    },
    playSound() {
      if (this.soundIsPlay == true || this.soundIsPlay == undefined) {
        var audio = new Audio(this.sound.soundurl);
        audio.play();
      }
    },
    setSoundInterval: function () {
      this.topListChangeInterval = setInterval(() => {
        this.playSound2();
      }, 1500);
    },
    clearSoundInterval: function () {
      clearInterval(this.topListChangeInterval);
      this.topListChangeInterval = null;
    },
    convertFullTimeToMMss: function (time) {
      let minuts = 0;
      let seconds = 0;
      const timeArr = time.split(':');
      const dayAndHourArr = timeArr[0].split('.');
      convertDayToMinuts();
      function convertDayToMinuts() {
        if (dayAndHourArr?.length === 2) {
          const days = +dayAndHourArr[0];
          const hours = +dayAndHourArr[1];
          const timeMinutes = +timeArr[1];
          minuts = days * 24 * 60 + hours * 60 + timeMinutes;
        } else {
          const hours = +dayAndHourArr[0];
          const timeMinutes = +timeArr[1];
          minuts = hours * 60 + timeMinutes;
        }
      }
      seconds = timeArr[2].split('.')[0];
      return `${minuts.toString()?.padStart(2, '0')}:${seconds.toString()?.padStart(2, '0')}`;
    },
    convertMinutesToTime(minutes) {
      if (!minutes || minutes < 0) return '00:00:00';
      const totalSeconds = Math.floor(minutes * 60);
      const hours = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      const secs = totalSeconds % 60;
      return [
        hours.toString().padStart(2, '0'),
        mins.toString().padStart(2, '0'),
        secs.toString().padStart(2, '0'),
      ].join(':');
    },
    playSound2() {
      const audio = new Audio(this.sound.soundurl);
      audio.play();
    },
    stopSound2: function () {
      this.topListSoundStop = true;
    },
    playSound3() {
      setTimeout(() => {
        var audio = new Audio(this.sound.soundurl);
        audio.play();
      }, 1000);
    },
    playSound800BottomList() {
      var audio = new Audio(this.sound2.soundurl);
      audio.play();
    },
    getLocalStream: function () {
      navigator.mediaDevices
        .getUserMedia({ video: false, audio: true })
        .then((stream) => {
          window.localStream = stream; // A
          window.localAudio.srcObject = stream; // B
          window.localAudio.autoplay = true; // C*/
        })
        .catch((err) => {
          console.error(`you got an error: ${err}`);
        });
    },
    showAlert: function (text, color, icon, timeout) {
      this.$root.$refs.appView.$refs.snackRef.snackModel = true;
      this.$root.$refs.appView.$refs.snackRef.snackColor = color;
      this.$root.$refs.appView.$refs.snackRef.snackText = text;
      this.$root.$refs.appView.$refs.snackRef.snackIcon = icon;
      this.$root.$refs.appView.$refs.snackRef.snakTimeOut = timeout;
    },
    showErrorAlert: function (text, timeout = 10000) {
      this.showAlert(text, '#FF5252', 'mdi-information', timeout);
    },
    showSuccessAlert: function (text, timeout = 10000) {
      this.showAlert(text, '#3BCA79', 'mdi-information', timeout);
    },
    isMissingCall: function (callResult) {
      return callResult === 'تماس از دست رفته	';
    },
    fenceCentering: function (latLngs) {
      if (latLngs) {
        const position = latLngBounds(latLngs);
        setTimeout(() => {
          this.$refs.fancemap?.mapObject?.fitBounds(position);
        }, 200);
      }
    },
    convertSecondsToHHMMss: function (time) {
      const hours = Math.floor(time / 3600)
        .toString()
        .padStart(2, '0');
      const minutes = Math.floor((time % 3600) / 60)
        .toString()
        .padStart(2, '0');
      const seconds = Math.floor((time % 3600) % 60)
        .toString()
        .padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    },
    removeDuplicated: function (arr, propertyName) {
      return arr.filter(
        (obj, index, self) =>
          self.findIndex((item) => item[propertyName] === obj[propertyName]) !== index,
      );
    },
    setTitles: function (titles, length, separator = '-') {
      const newTitles = titles
        ?.filter((title) => !!title?.toString()?.trim())
        ?.filter((item, index) => index < length && !!item);
      return newTitles.join(separator);
    },
    getFullName: function (
      data,
      firstNameKey = 'firstName',
      lastNameKey = 'lastName',
      optionalKey = 'userName',
    ) {
      return data?.[firstNameKey] && data?.[lastNameKey]
        ? `${data[firstNameKey]} ${data[lastNameKey]}`
        : data?.[optionalKey]
          ? data[optionalKey]
          : '-';
    },
    getJalaliDate: function (date) {
      return `${new Date(date).toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })} ${new Date(date).toLocaleTimeString('fa-IR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })}`;
    },
    initialFromDate: function (fromDate) {
      if (fromDate) return fromDate;
      else {
        const today = new Date();

        const formattedDate = `${new Intl.DateTimeFormat('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).format(today)}T00:00:00`;
        return formattedDate;
      }
    },
    getLocalISODateString: function (date) {
      const timezoneOffset = date.getTimezoneOffset() * 60 * 1000;
      const localDate = new Date(date.getTime() - timezoneOffset);
      const isoString = localDate.toISOString().slice(0, -1);
      return isoString;
    },
  },
  // beforeUnmount() {
  //   console.log(this.$route?.fullPath, 'beforeUnMount');
  // },

  computed: {
    is800Section: function () {
      const currentRoute = this.$route.path;
      if (currentRoute == '/dashboards/800') {
        return false;
      }
      return currentRoute.includes('800');
    },
    accessDenyAddEditChief() {
      const url = window.localStorage.getItem('x_asayarAcc_as');
      return !!(url && url.toString() == "@sayar$dv");
    }
  },
};
